export enum InformType {
  Success,
  Danger,
  Warning,
  Info,
  Anything
}
